<template>
  	<div class="stores">
    	<div class="breadcrumb">小乔花名 > 花名列表</div>
    	<div class="searchBtn">
	      	<div class="search_item">
	      		<div>姓名</div>
	        	<input type="text" placeholder="请输入员工姓名" class="el-input__inner" v-model="userName" @keyup.enter="search_mine()"/>
	      	</div>

	      	<div class="search_item">
	      		<div>花名</div>
	        	<input type="text" placeholder="请输入员工花名" class="el-input__inner" v-model="aliasName" @keyup.enter="search_mine()"/>
	      	</div>
	      	<div class="search_item">
	      		<div>性别</div>
				<el-select v-model="sex" placeholder="请选择员工性别">
				    <el-option
				      	v-for="item in sexList"
				      	:key="item.label"
				      	:label="item.label"
				      	:value="item.label">
				    </el-option>
			  	</el-select>
		  	</div>
		  	<div class="search_item">
	      		<div>状态</div>
				<el-select v-model="approvalStatus" placeholder="请选择审核状态">
				    <el-option
				      	v-for="item in approvalStatusList"
				      	:key="item.value"
				      	:label="item.label"
				      	:value="item.value">
				    </el-option>
			  	</el-select>
		  	</div>
			<el-button type="primary" @click="search_mine()">搜索</el-button>
			<el-button type="danger" @click="del()">删除</el-button>
			<el-button type="warning" @click="restore()">恢复</el-button>
    	</div>

    	<!-- <div class="topnav" style="margin:15px 0 20px">
	    	<li :class="{active:cur==1}" @click="topnav(1)">全部</li>
	    	<li :class="{active:cur==3}" @click="topnav(3)">删除列表</li>
	    </div> -->

    	<div class="main">
	      	<template>
	        	<el-table
	          		ref="multipleTable"
	          		:data="tableData"
	          		tooltip-effect="dark"
	          		style="width: 100%"
    				@selection-change="handleSelectionChange"
	          		>
	          		<el-table-column type="selection"
				      width="55">
				    </el-table-column>
		          	<el-table-column prop="id"  label="ID"></el-table-column>
		          	<el-table-column prop="userName"  label="员工名称"></el-table-column>
		          	<el-table-column prop="aliasName" label="员工花名"></el-table-column>
		          	<el-table-column prop="sex" label="性别"></el-table-column>
		          	<el-table-column prop="departmentName" label="部门"></el-table-column>
		          	<el-table-column label="状态">
		          		<template slot-scope="scope" >
			            	{{scope.row.approvalStatus==0?'未审核':
	        				scope.row.approvalStatus==1?'审核通过':
	        				scope.row.approvalStatus==2?'审核失败':'已删除'}}
			        	</template>
		          	</el-table-column>
		          	<el-table-column label="操作">
		          		<template slot-scope="scope" >
			            	<el-button type="primary" size='small' :disabled="scope.row.approvalStatus!=0" @click="updCompanyUserAlias(scope.row,1)">通过</el-button>
			            	<el-button type="primary" size='small' :disabled="scope.row.approvalStatus!=0" @click="updCompanyUserAlias(scope.row,2)">拒绝</el-button>
			        	</template>
		          	</el-table-column>
	        	</el-table>
	      	</template>
      		<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination
		          	@current-change="handleCurrentChangePage"
		          	:current-page="pageNum"
		          	:page-size="limit"
		          	layout="total, prev, pager, next, jumper"
		          	:total="totalPage"
	        	></el-pagination>
      		</div>
    	</div>
    	
  	</div>
</template>

<script>
export default {
  	components: {},
  	mounted() {
    	this.init();
  	},
  	data() {
    	return {
      		headers: {
        		xqiao_token: localStorage.getItem("token")
      		},
      		userName:'',
      		aliasName:'',
      		sex:'',
      		approvalStatus:'',
	      	tableData: [],
	      	pageNum: 1,
	      	limit: 10,
	      	totalPage: 10,
	      	sexList:[{label:'男'},{label:'女'}],
	      	approvalStatusList:[
	      		{value:0,label:'未审核'},
	      		{value:1,label:'审核通过'},
	      		{value:2,label:'审核失败'},
	      		{value:3,label:'删除列表'}
	      	],
	      	multipleSelection:[],
	      	// cur:1
    	};
  	},
  	methods: {
    	//初始化表格数据
    	init() {
      		var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		userName:this.userName,
        		aliasName:this.aliasName,
        		sex:this.sex,
        		approvalStatus:this.approvalStatus,
      		};
      		this.$get("/company/getCompanyUserAliasList", params)
        	.then(res => {
          		if (res.code == 0) {
            		this.tableData = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
        	.catch(() => {
          		console.log();
        	});
    	},
    	// topnav(val){
    	// 	this.cur=val;
    	// 	if(val==3){
    	// 		this.approvalStatus=3
    	// 	}else{
    	// 		this.approvalStatus=''
    	// 	}
    	// 	this.init();
    	// },
    	//当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.init();
	    },
	    search_mine(){
	    	this.init();
	    },
	    updCompanyUserAlias(row,status){
	    	var data={};
	    	data=row
	    	if(status==1){
	    		data.approvalStatus=1
	    	}else{
	    		data.approvalStatus=2
	    	}
	    	this.$post("/company/updCompanyUserAlias",JSON.stringify(data))
	        .then(res => {
	          	if (res.code == 0) {
		            this.$message({
		              	message: "操作成功",
		              	type: "success"
		            });
		            this.pageNum=1;
		            this.init();
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	           }
	        })
	    },
	    handleSelectionChange(val) {
	        this.multipleSelection = val;
	        console.log(this.multipleSelection)
	    },
	    del(){
	    	if(this.multipleSelection.length>0){
	    		this.$post("/company/delete",JSON.stringify(this.multipleSelection))
		        .then(res => {
		          	if (res.code == 0) {
			            this.$message({
			              	message: "操作成功",
			              	type: "success"
			            });
			            this.pageNum=1;
			            this.approvalStatus='';
			            this.init();
		          	} else {
			            this.$message({
			              	message: res.message,
			              	type: "warning"
			            });
			            return false;
		           }
		        })
	    	}else{
	    		this.$message({
	              	message: '至少选择一条删除~',
	              	type: "warning"
	            });
	    	}
	    },
	    restore(){
	    	if(this.multipleSelection.length>0){
	    		this.$post("/company/restore",JSON.stringify(this.multipleSelection))
		        .then(res => {
		          	if (res.code == 0) {
			            this.$message({
			              	message: "操作成功",
			              	type: "success"
			            });
			            this.pageNum=1;
			            this.approvalStatus='';
			            this.init();
		          	} else {
			            this.$message({
			              	message: res.message,
			              	type: "warning"
			            });
			            return false;
		           }
		        })
	    	}else{
	    		this.$message({
	              	message: '至少选择一条恢复~',
	              	type: "warning"
	            });
	    	}
	    }
  	}
};
</script>

<style scoped>
.searchBtn{
	display:flex
}
.search_item{
	display: flex;
	font-size:13px;
	align-items: center;
	margin-right: 20px
}
.search_item div{
	margin-right: 10px;
}
.search_item input{
	flex: 1
}

</style>



// WEBPACK FOOTER //
// src/views/stageName/index.vue